var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.articles.length)?_c('div',{staticClass:"related-articles"},[_c('p',{staticClass:"h4"},[_vm._v("\n    Related Articles\n  ")]),_vm._v(" "),_c('ul',_vm._l((_vm.articles),function({ slug, title },idx){return _c('li',{key:idx},[_c('nuxt-link',{attrs:{"to":`/support/${slug}/`}},[_vm._v("\n        "+_vm._s(title)+"\n      ")])],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }